import React, { FC, useContext, useRef } from 'react';
import styles from './MainSlider.module.scss';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { MainSliderImageModel } from './types';
import { Navigation, Autoplay } from 'swiper';
import { Swiper, SwiperRef, SwiperSlide } from 'swiper/react';
import leftArrow from '../../assets/img/arrowLeft.svg';
import rightArrow from '../../assets/img/arrowRight.svg';

import 'swiper/css';
import { generateImageUrl } from '../../utils/cdnService';
import { AuthContext } from '../../context/auth';

type Props = {
  images: MainSliderImageModel[];
};
const MainSlider: FC<Props> = ({ images }) => {
  const {
    i18n: { language },
  } = useTranslation();
  const navigate = useNavigate();
  const authContext = useContext(AuthContext);
  const { isAuthenticated } = authContext;

  const ref = useRef<SwiperRef | null>(null);

  const handleNext = () => {
    if (ref.current !== null && ref.current.swiper !== null) {
      ref.current.swiper?.slideNext();
    }
  };

  const handlePrev = () => {
    if (ref.current !== null && ref.current.swiper !== null) {
      ref.current.swiper?.slidePrev();
    }
  };
  const params = {
    loop: true,
    speed: 1500,
    autoplay: {
      delay: 10000,
      disableOnInteraction: false,
    },
    allowTouchMove: true,
    preventClicks: false,
    preventClicksPropagation: false,
    navigation: {
      nextEl: `${styles.nextButton}`,
      prevEl: `${styles.prevButton}`,
    },
    slidesPerView: 1,
    effect: 'slide',
    grabCursor: true,
  };

  const handleClick = (url: string | null) => {
    if (!isAuthenticated) {
      return;
    }

    if (url) {
      navigate(`${language}${url}`);
    }
  };

  return (
    <div className={`${styles.mainSlider} ${isAuthenticated ? styles.cursorPointer : styles.cursorAuto}`}>
      <Swiper ref={ref} className={styles.mainSlider} modules={[Navigation, Autoplay]} {...params}>
        {images &&
          images.map((image) => {
            return (
              <SwiperSlide key={image.id}>
                <div onClick={() => handleClick(image.url)}>
                  <img src={generateImageUrl('gcore', 0, 0, image.image)} alt="" />
                </div>
              </SwiperSlide>
            );
          })}
      </Swiper>
      <div onClick={handleNext} className={styles.nextButton}>
        <img src={rightArrow} alt="" />
      </div>
      <div onClick={handlePrev} className={styles.prevButton}>
        <img src={leftArrow} alt="" />
      </div>
    </div>
  );
};
export default MainSlider;
